<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    var sheetIndex = [...document.styleSheets].findIndex((x) => {
      try {
        return (
          [...x.cssRules].findIndex(
            (x) => x.selectorText == ".dx-theme-generic-typography"
          ) != -1
        );
      } catch {
        return false;
      }
    });

    var sheet = document.styleSheets[sheetIndex];
    var rule = [...sheet.cssRules].findIndex(
      (x) => x.selectorText == ".dx-theme-generic-typography"
    );
    sheet.deleteRule(rule);
  },
};
</script>

<style>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body,
p {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden auto;
  height: 100vh;
  background-color: #eee;
}

.placeholder {
  outline: 3px dashed #444;
  outline-offset: -6px;
  /* transition position changing */
  -webkit-transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
  background-color: transparent !important;
  opacity: 1;
}

.flex-full {
  display: flex;
  width: 100%;
  min-width: 400px;
  justify-content: space-between;
  margin: 5px 0;
}

.dx-datagrid{
  border-radius: 10px;
}

.no-wrap{
  white-space: nowrap;
}

.w-full {
  width:100%;
}

.w-half{
  width:50%;
}

.h-full {
  height: 100%;
}

.h-half{
  height:50%;
}

.bold{
  font-weight: bold;
}
</style>
